import React from 'react'
import { connect } from 'react-redux'
import { getTranslate } from 'react-localize-redux'
import Paper from 'material-ui/Paper'
import Typography from 'material-ui/Typography'
import Grid from 'material-ui/Grid'
import TextField from 'material-ui/TextField'
import Button from 'material-ui/Button'
import Select from 'material-ui/Select'
import Input, { InputLabel } from 'material-ui/Input'
import { FormControl, FormControlLabel, FormHelperText } from 'material-ui/Form'
import { MenuItem } from 'material-ui/Menu'
import Checkbox from 'material-ui/Checkbox'
import { withStyles } from 'material-ui/styles'
import {
  getEmployeeRangeOptions,
  getEquipmentUseOptions,
  getOrganisationActivityOptions
} from '../../../common/organisation-preferences'
import {
  getOrganisationPreferences,
  updateOrganisationPreferences
} from '../../../redux/actions/organisationPreferencesActions'
import styles from './styles'

const toFormData = data => ({
  address: data.address || '',
  city: data.city || '',
  state: data.state || '',
  country: data.country || '',
  zipcode: data.zipcode || '',
  language: data.language || 'en-GB',
  chartmeasurement: data.chartmeasurement || 'Meters',
  chartlinestyle: data.chartlinestyle || 'Standard',
  wiremapdisplaypreference: data.wiremapdisplaypreference || 'Standard',
  organisationactivities: data.organisationactivities || [],
  organisationactivityother: data.organisationactivityother || '',
  fieldtechnicianrange: data.fieldtechnicianrange || '',
  equipmentusage: data.equipmentusage || [],
  equipmentusageother: data.equipmentusageother || '',
  testingapplications: data.testingapplications || ''
})

class Preferences extends React.Component {
  state = {
    errors: {},
    form: null,
    saved: false,
    submitError: ''
  }

  componentDidMount() {
    if (this.props.data) {
      this.setState({ form: toFormData(this.props.data) })
      return
    }

    this.props.getPreferences().catch(() => {})
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data && nextProps.data !== this.props.data) {
      this.setState({
        errors: {},
        form: toFormData(nextProps.data),
        saved: false,
        submitError: ''
      })
    }
  }

  handleChange = name => event => {
    const value = event.target.value

    this.setState(previousState => ({
      errors: { ...previousState.errors, [name]: null },
      form: { ...previousState.form, [name]: value },
      saved: false,
      submitError: ''
    }))
  }

  handleMultiSelectChange = (name, value) => event => {
    const isChecked = event.target.checked

    this.setState(previousState => {
      const selected = previousState.form[name] || []
      return {
        errors: { ...previousState.errors, [name]: null },
        form: {
          ...previousState.form,
          [name]: isChecked ? [...selected, value] : selected.filter(item => item !== value)
        },
        saved: false,
        submitError: ''
      }
    })
  }

  validate = () => {
    const { form } = this.state
    const { translate } = this.props
    const errors = {}

    if (!form.organisationactivities.length) {
      errors.organisationactivities = translate('organisation_preferences_activity_required')
    }
    if (form.organisationactivities.includes('Other (please specify)') && !form.organisationactivityother.trim()) {
      errors.organisationactivityother = translate('organisation_preferences_other_activity_required')
    }
    if (!form.fieldtechnicianrange) {
      errors.fieldtechnicianrange = translate('formfield_error_general_required')
    }
    if (!form.equipmentusage.length) {
      errors.equipmentusage = translate('organisation_preferences_equipment_required')
    }
    if (form.equipmentusage.includes('Other') && !form.equipmentusageother.trim()) {
      errors.equipmentusageother = translate('organisation_preferences_other_equipment_required')
    }
    if (!form.testingapplications.trim()) {
      errors.testingapplications = translate('formfield_error_general_required')
    }

    this.setState({ errors })
    return Object.keys(errors).length === 0
  }

  save = () => {
    if (!this.validate()) return

    this.props.updatePreferences(this.state.form)
      .then(response => {
        if (!response || !response.payload || !response.payload.data || !response.payload.data.success) {
          const message = response && response.payload && response.payload.data && response.payload.data.errors
          this.setState({ submitError: message || this.props.translate('organisation_preferences_save_error') })
          return
        }

        this.setState({ saved: true, submitError: '' })
      })
      .catch(() => this.setState({ submitError: this.props.translate('organisation_preferences_save_error') }))
  }

  renderSelect = (name, label, options) => {
    const { classes } = this.props
    const { errors, form } = this.state

    return (
      <FormControl className={classes.formControl} error={Boolean(errors[name])} required>
        <InputLabel htmlFor={`profile-preferences-${name}`}>{label}</InputLabel>
        <Select
          input={<Input id={`profile-preferences-${name}`} name={name} />}
          onChange={this.handleChange(name)}
          value={form[name]}
        >
          {options.map(option => (
            <MenuItem key={option.value || option} value={option.value || option}>
              {option.label || option}
            </MenuItem>
          ))}
        </Select>
        {errors[name] && <FormHelperText>{errors[name]}</FormHelperText>}
      </FormControl>
    )
  }

  renderOtherInput = (name, label) => {
    const { errors, form } = this.state

    return (
      <TextField
        error={Boolean(errors[name])}
        fullWidth
        helperText={errors[name]}
        label={label}
        margin="normal"
        onChange={this.handleChange(name)}
        required
        value={form[name]}
      />
    )
  }

  renderMultiSelect = (name, label, options, otherName) => {
    const { classes, translate } = this.props
    const { errors, form } = this.state
    const selected = form[name] || []
    const hasOther = selected.includes('Other') || selected.includes('Other (please specify)')

    return (
      <div className={classes.questionGroup}>
        <Typography className={classes.questionLabel}>{label}</Typography>
        <div className={classes.checkboxList}>
          {options.map(option => {
            const value = option.value || option
            const optionLabel = option.label || option
            return (
            <FormControlLabel
              className={classes.checkboxControl}
              control={
                <Checkbox
                  checked={selected.includes(value)}
                  color="primary"
                  onChange={this.handleMultiSelectChange(name, value)}
                />
              }
              key={value}
              label={optionLabel}
            />
            )
          })}
        </div>
        {errors[name] && <FormHelperText error>{errors[name]}</FormHelperText>}
        {hasOther && this.renderOtherInput(otherName, translate('signup_please_specify'))}
      </div>
    )
  }

  render() {
    const { classes, error, loading, updating, translate } = this.props
    const { form, saved, submitError } = this.state

    if (!form) {
      return (
        <Paper className={classes.paper}>
          <Typography className={classes.heading} component="h2">
            {translate('organisation_preferences')}
          </Typography>
          <Typography>{error ? translate('organisation_preferences_load_error') : translate('organisation_preferences_loading')}</Typography>
        </Paper>
      )
    }

    return (
      <Paper className={classes.paper}>
        <Typography className={classes.heading} component="h2">
          {translate('organisation_preferences')}
        </Typography>
        <Typography className={classes.description}>
          {translate('organisation_preferences_work_copy')}
        </Typography>

        <Grid container spacing={16}>
          <Grid item xs={12}>
            {this.renderMultiSelect('organisationactivities', translate('organisation_activities'), getOrganisationActivityOptions(translate), 'organisationactivityother')}
          </Grid>
          <Grid item xs={12} sm={6}>
            {this.renderSelect('fieldtechnicianrange', translate('organisation_field_team_size'), getEmployeeRangeOptions(translate))}
          </Grid>
          <Grid item xs={12}>
            {this.renderMultiSelect('equipmentusage', translate('organisation_equipment_use'), getEquipmentUseOptions(translate), 'equipmentusageother')}
          </Grid>
          <Grid item xs={12}>
            <TextField
              error={Boolean(this.state.errors.testingapplications)}
              fullWidth
              helperText={this.state.errors.testingapplications}
              label={translate('organisation_testing_applications')}
              margin="normal"
              multiline
              onChange={this.handleChange('testingapplications')}
              required
              rows={3}
              value={form.testingapplications}
            />
          </Grid>
        </Grid>

        {submitError && <Typography className={classes.error}>{submitError}</Typography>}
        {saved && <Typography className={classes.saved}>{translate('organisation_preferences_saved')}</Typography>}

        <Button className={classes.button} color="primary" disabled={updating || loading} onClick={this.save} raised>
          {updating ? `${translate('organisation_preferences_save')}...` : translate('organisation_preferences_save')}
        </Button>
      </Paper>
    )
  }
}

const mapStateToProps = state => ({
  data: state.organisationPreferencesReducer.data,
  error: state.organisationPreferencesReducer.error,
  loading: state.organisationPreferencesReducer.loading,
  translate: getTranslate(state.localeReducer),
  updating: state.organisationPreferencesReducer.updating
})

const mapDispatchToProps = dispatch => ({
  getPreferences: () => dispatch(getOrganisationPreferences()),
  updatePreferences: data => dispatch(updateOrganisationPreferences(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Preferences))
